import { Box, Button, Card, Divider, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useRef } from "react";
import JobTreeLogo from "../assets/images/JobTreeLogo.jpg";

const LetterHead = () => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          mx: 4,
          mt: 1,
        }}
      >
        {" "}
        <Box sx={{ flex: 1 }}>
          <img src={JobTreeLogo} alt="company-logo" width="100px" />
          {/* <Typography variant="h4" color="error">
            Job Tree Placement Servcies
          </Typography> */}
        </Box>
        <Box sx={{ marginRight: 0, maxWidth: 600 }}>
          <Typography variant="h4" color="primary">
            <Box component="span" sx={{ color: "chocolate" }}>
              Job
            </Box>{" "}
            <Box component="span" sx={{ color: "darkgreen" }}>
              Tree
            </Box>{" "}
            <Box component="span">Placement Services</Box>
          </Typography>
          <Typography sx={{ fontSize: "11px" }}>
            <b>Address:</b>1st Floor,Balkrishna Complex,
            <br />
            Near Hotel Priyadarshani,Hira Hotel Chowk,
            <br /> Miraj, Maharashtra 416410
            <br />
            <b>Mobile No.:</b> +91-7720056190
          </Typography>
        </Box>
      </Box>
      <Divider
        sx={{ borderBottomWidth: 1, mt: 1, mb: 2, bgcolor: "#000000" }}
      />
    </Box>
  );
};

export default LetterHead;
